import store from "./../../Common/storage";
import logger from "./../../logger";
import sha256 from 'sha256';
import {
  getAccessToken,
  setTokens,
  clearTokens,
} from './../../services/tokenStore';

export const hashString = plaintext => sha256(plaintext);

// ── User data (non-sensitive — stays in localStorage) ────────────────────────

export const getUser = () => store.get("user") || null;

export const saveUser = (user) => store.set("user", user);

// ── Token access (delegated to tokenStore) ───────────────────────────────────

// Kept for backward compat — all existing callers continue to work unchanged.
export const getToken = () => getAccessToken();

// ── Session lifecycle ────────────────────────────────────────────────────────

/**
 * Persist tokens via tokenStore (memory or localStorage depending on TOKEN_STORAGE)
 * and write non-sensitive user/config data to localStorage.
 */
export const setUserSession = (accesstoken, refreshtoken, _expires_in, user) => {
  logger.log("setUserSession", user);
  store.clear();
  setTokens(accesstoken, refreshtoken);
  store.set("user", user);
  store.set("c_id_index", 0);
  if (user.configs && user.configs.length === 1) {
    store.set("c_id", user.configs[0].id);
  }
};

/**
 * Store tokens only — used when user/config data is managed separately.
 */
export const setUserTokens = (accesstoken, refreshtoken) => {
  setTokens(accesstoken, refreshtoken);
};

/**
 * Clear tokens (via tokenStore) and all localStorage session data.
 */
export const removeUserSession = () => {
  logger.log("removeUserSession");
  clearTokens();
  store.clear();
};

export const getHeaders = () => {
  const token = getToken();
  if (!token) return {};
  return { headers: { Authorization: `Bearer ${token}` } };
};
